import { useSuspenseQuery } from '@connectrpc/connect-query'

import { authTransport } from '@jotta/grpc-connect-client/transport'
import { getPaymentInfo } from '@jotta/grpc-connect-openapi/subscriptionQuery'
import { Redirect } from '@jotta/ui/Redirect'

import { useBizUsers } from '../BizApi'
import { BizCompanyInformationForm } from '../components/BizCompanyInformationForm'
import { BizPaymentInformation } from '../components/BizPaymentInformation'
import { BizSubscriptionForm } from '../components/BizSubscriptionForm'
import { BizTerminateAccountForm } from '../components/BizTerminateAccountForm'

export function BizSettingsRoute() {
  const { data: paymentInfo } = useSuspenseQuery(
    getPaymentInfo,
    {},
    { transport: authTransport },
  )

  const { maxUserCount, users } = useBizUsers()
  const userCount = users.length
  const changeSubscriptionOption = paymentInfo.changeSubscriptionOption

  if (changeSubscriptionOption?.case === 'manageSubscriptionExternally') {
    return <Redirect to={changeSubscriptionOption.value.url} />
  }

  return (
    <>
      <div className="grid max-w-4xl grid-cols-1 grid-rows-3 gap-3 md:grid-cols-max-fr1">
        <div className="row-span-3 grid">
          <BizCompanyInformationForm />
        </div>
        <BizSubscriptionForm
          paymentInfo={paymentInfo}
          userCount={userCount}
          maxUserCount={maxUserCount}
        />
        <BizPaymentInformation paymentInfo={paymentInfo} />
        <BizTerminateAccountForm />
      </div>
    </>
  )
}
